import {
    useState,
    forwardRef,
    useImperativeHandle,
    createRef
} from 'react'
import PhoneNumberInput from '../PhoneNumberInput'

const PhoneNumberList = forwardRef(({ data = [], readOnly }, ref) => {

    const [entries, setEntries] = useState(() => {
        if (data.length > 0) {
            return data.map((entry) => ({
                ref: createRef(),
                value: entry,
            }))
        }
        return [{ ref: createRef(), value: null }]
    })

    const addPhone = () => {
        if (entries.length < 3) {
            setEntries([...entries, { ref: createRef(), value: null }])
        }
    }

    const removePhone = (index) => {
        if (entries.length > 1) {
            setEntries(entries.filter((_, i) => i !== index))
        }
    }

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const results = entries.map((entry) => entry.ref.current?.validateAndGetData?.())
            const isValid = results.every((r) => r?.isValid)
            return {
                isValid,
                value: results.map((r) => r?.value),
            }
        },
    }))

    return (
        <div className="space-y-4">
            {entries.map((entry, index) => {
                const isLast = index === entries.length - 1
                const canAdd = entries.length < 3 && isLast
                const canRemove = entries.length > 1 && !readOnly

                return (
                    <div
                        key={index}
                        className="grid md:grid-cols-[1fr_100px] grid-cols-1 items-center gap-3"
                    >

                        <PhoneNumberInput
                            ref={entry.ref}
                            data={entry.value}
                            readOnly={readOnly}
                        />

                        {!readOnly && (
                            <div className="flex justify-end md:items-center">
                                {canAdd && (
                                    <button
                                        type="button"
                                        onClick={addPhone}
                                        className="w-[100px] px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600"
                                    >
                                        + Add
                                    </button>
                                )}
                                {canRemove && !canAdd && (
                                    <button
                                        type="button"
                                        onClick={() => removePhone(index)}
                                        className="w-[100px] px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
})

export default PhoneNumberList
